import $ from 'jquery'

import BaseComponent from 'scripts/components/base-component'

const DEFAULTS = {
  showClass: 'visible'
}

class Overlay extends BaseComponent {
  static componentName = 'overlay'

  static emitterEvents = {
    'overlay:show': 'show',
    'overlay:hide': 'hide'
  }

  constructor (element, options = {}) {
    super(element)
    this.options = $.extend({}, DEFAULTS, options)
  }

  show () {
    this.$element.addClass(this.options.showClass)
  }

  hide () {
    this.$element.removeClass(this.options.showClass)
  }
}

export default ($el) => new Overlay($el)

export { Overlay as Component }
